//Start Header
document.addEventListener('DOMContentLoaded', startHeader,  {once : true});


//De facut functionalitate de la mobil -> desktop


function startHeader(){
  //Show current page
  showCurrent();
  //Get elements
  let buttons = document.querySelectorAll('.menu-element'),
      dropdowns = document.querySelectorAll('header .dropdown'),
      subButtons = document.querySelectorAll('.menu-element:not(.grid) .item'),
      overlay = document.querySelector('.overlay'),
      burger = document.querySelector('.mobile-nav-burger'),
      websiteWrapper = document.querySelector('.website-wrapper'),
      primaryNav = document.querySelector('.primary-nav-wrapper'),
      windowWidth = document.body.clientWidth, //width of window without the scrollbar
      timeOut, 
      previousEvent = null;

  //Initializez headerul
  if(window.innerWidth > 991){
    setDesktop();
  }
  else{
    setMobile();
  }

  //Setez event listeners atat pentru mobil, cat si pentru desktop. 
  //Se seteaza o singura data si se apeleaza functiile in functie de cazul in care esti. 
  buttons.forEach( (button) =>{
    if(button.querySelector('.dropdown')){
      
      //Desktop - hover over buttons -> opens 
      button.addEventListener('pointerenter', (event) => {
        switch (event.pointerType) {          
          case 'mouse':
          case 'pen':
              if(window.innerWidth > 991){
                //Deschid dropdown
                openDropdown(event);
                //Ascult pentru inchidere dropdown
                button.addEventListener('pointerleave', closeDropdown, {once : true});
              }
              break
          case 'touch':
              if(window.innerWidth > 991){
                //Verific daca am deja un dropdown deschis si il inchid
                if(previousEvent)
                  closeDropdown(previousEvent);
                previousEvent = event;
                //Deschid dropdown-ul curent
                openDropdown(event);
                //Ascult dupa interactiune cu overlay-ul si inchid ultimul event 
                overlay.addEventListener('click', (ev)=>{
                  closeDropdown(previousEvent);      
                },{once : true});
              }
            break
        }
      });
      
      //Mobil - tap/click on buttons -> opens
      //Deschid dropdown nivel 1
      button.addEventListener('pointerdown', (event)=>{
        event.currentTarget.addEventListener('pointerup',(e)=>{ 
          if(!e.currentTarget.querySelector('.dropdown.display')){   
            e.currentTarget.querySelector('.dropdown').classList.add('display');
            e.currentTarget.querySelector('.icon-arrow').classList.add('up'); 
            //Ascult dupa X pentru inchidere dropdown
            e.currentTarget.querySelector('.icon-arrow.up').addEventListener('pointerdown',(ev) => {
              let isTap = true;
              ev.currentTarget.addEventListener('pointermove',(e)=>{ isTap = false; } ,{once : true});
              ev.currentTarget.addEventListener('pointerup',(evv)=>{ 
                evv.currentTarget.parentNode.querySelector(".dropdown.display").classList.remove('display');
                evv.currentTarget.parentNode.querySelector(".icon-arrow.up").classList.remove('up');
                //Daca am dropdown nivel 2 deschis, il inchid si pe el
                if(evv.currentTarget.parentNode.querySelector(".secondary-dropdown.display"))
                  evv.currentTarget.parentNode.querySelector(".secondary-dropdown.display").classList.remove('display');
                if(evv.currentTarget.parentNode.querySelector(".item .icon-arrow.up"))
                  evv.currentTarget.parentNode.querySelector(".item .icon-arrow.up").classList.remove('up');
                evv.preventDefault();
                evv.stopImmediatePropagation();
              },{once : true}); 
            }, {once : true});
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        });
      }); 
      
    }
  });

  //Ascult butoane nivel 2  si deschid Dropdowns nivel 2       
  subButtons.forEach((subButton) => {
      //Deschid dropdown nivel 2
      subButton.addEventListener('pointerdown', (event) =>{
        if(window.innerWidth < 991){
              event.currentTarget.addEventListener('pointerup',(e)=>{ 
                  e.currentTarget.querySelector('.secondary-dropdown').classList.add('display');
                  e.currentTarget.querySelector('.icon-arrow').classList.add('up');        
                  //Ascultare dupa inchidere dropdown nivel 2
                  e.currentTarget.querySelector('.icon-arrow.up').addEventListener('pointerdown',(ev)=>{
                    let isTap = true;
                    ev.currentTarget.addEventListener('pointermove', (e)=>{ isTap = false; }, {once : true});
                    //Inchid downdown nivel 2
                    ev.currentTarget.addEventListener('pointerup', (evv) => {
                       evv.currentTarget.parentNode.querySelector(".secondary-dropdown.display").classList.remove('display');
                       evv.currentTarget.parentNode.querySelector(".item .icon-arrow.up").classList.remove('up');
                       evv.preventDefault();
                       evv.stopPropagation();
                       evv.stopImmediatePropagation();
                    }, {once : true});  
                    ev.preventDefault();
                    ev.stopPropagation();
                    ev.stopImmediatePropagation();
                  },{once : true});  
              },{once : true}); 
         }
      });
  });

  
  //Deschidere dropdown & overlay Desktop
  function openDropdown(e){
    e.target.querySelector('.dropdown').classList.add('display');
    overlay.classList.add('show-overlay');
  } 
  //Inchidere dropdown & overlay Desktop
  function closeDropdown(e){
    e.target.querySelector('.dropdown').classList.remove('display');
    overlay.classList.remove('show-overlay');
    previousEvent = null;
  }
  
  //Ascult pentru deschidere burger
  burger.addEventListener('pointerdown', (event)=>{
      burger.addEventListener('pointerup',(e)=>{ 
          //Ascult dupa butoanele nivel 1
          // setMenu();
          //Deschid meniul
          overlay.classList.add('show-overlay');
          websiteWrapper.style.pointerEvents = 'none';
          document.body.style.overflow = 'hidden';
          primaryNav.classList.add('display');
      },{once : true});
  });
  
  //Ascult dupa inchiderea meniului pe tableta/mobil
  overlay.addEventListener('pointerdown', (event) => {
    if(window.innerWidth < 991){
      overlay.addEventListener('pointerup',(e)=>{ 
          //Inchid meniu
          primaryNav.classList.remove('display');
          overlay.classList.remove('show-overlay');
          websiteWrapper.style.pointerEvents = 'unset';
          document.body.style.overflow = 'auto';  
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
      },{once : true});
    }
  });
  
  //Setez dropdowns Desktop
  function setDesktop(){
    primaryNav.style.height = '';
    primaryNav.style.position = 'relative';
    windowWidth = document.body.clientWidth;
    const padding = (windowWidth - 1600)/2;
    let thisWidth = 0, 
        rightPosition = 0,
        newPosition = 0;
    //Setez pozitiile dropdown-urilor, in cazul in care dimensiunea lor e prea mare si ies din container in asezarea initiala.
    dropdowns.forEach( (element) =>{
      element.style.left = '0';
      thisWidth = element.offsetWidth;
      rightPosition = element.getBoundingClientRect().right;
      if(window.innerWidth > 1600 && rightPosition > windowWidth - padding){
        newPosition = rightPosition - 1600 - padding;
        element.style.left = `-${newPosition}px`;    
      }
      else if (window.innerWidth <= 1600 && rightPosition > windowWidth ){
        newPosition = rightPosition - windowWidth + 20;
        element.style.left = `-${newPosition}px`;
      }
      
    });
  } 
  //Setez dropdowns Mobil
  function setMobile(){
    dropdowns.forEach( (element) =>{
      element.style.left = '0';
      primaryNav.style.height = `${window.innerHeight}px`;
      primaryNav.style.position = 'fixed';
    });
  }
  
  //Ascult dupa resize de window
  new ResizeObserver(resetHeader).observe(document.body);

  //Reset Header la window resize
  function resetHeader(){
    clearTimeout(timeOut);

    timeOut = setTimeout(afterResize, 20);
  }
  
  function afterResize(){
    if(window.innerWidth > 991){
      setDesktop();
    }
    else{
      setMobile();
    }
  }
  
  // Show active page
  function showCurrent(){
    let currentHref = window.location.href.replace("https://mobexpert.ro","");
    let thisButton = document.querySelector('header').querySelectorAll(`[href="${currentHref}"]`);
    thisButton.forEach((buton) => {
      buton.classList.add('active');
    });  
  }
}


